import { iconStates } from '../../core/pixi/icons';
import { gameMainDrawer } from '../../game/drawers/gameMainDrawer';
import { getActualIcon } from '../standardSpinManager/standardSpinManager';
import { addToGameEvents } from '../../lib/gameEvents';

import { addToGameTimer, removeFromGameTimer } from '../../lib/timer';
import { applicationStore } from '../../store/applicationStore';
import { iframeService } from '../iframeService';
import { gameStore } from '../../store/gameStore';

import { winBarStore } from '../../store/winBarStore';
import { spinBarStore } from '../../store/spinBarStore';
import { MIN_BIG_WIN_POPUPS_ODD } from '../../helpers/getWinPopupType';
import { soundService, SoundTypes } from '../baseSoundService/soundService';
import { isMobile } from '../../helpers/isMobile';
import { removeFromGameLoop } from '../../lib/gameLoop';
// eslint-disable-next-line import/named
import { WinningLinesCoordinate100 } from '../../constants';

let subs = [];
let linesData;
let iterations;
let linWinTime;
let interrupted;
let nextLineTimeout;
let allLinePromise;
let allLineResolver;
let allLineGameTimeEvent;
let isAllWinLine = true;
let isSpinEnd = false;
let allLinesBones = [];
const activeEvents = {
  // eslint-disable-next-line no-use-before-define
  startWin,
  // eslint-disable-next-line no-use-before-define
  stopWin,
};

export const initWin = () => {
  subs.forEach((u) => u());
  subs.length = 0;
  subs = addToGameEvents(activeEvents);
};

// eslint-disable-next-line no-shadow
async function startAllLineWin(linesData) {
  isAllWinLine = false;
  linesData.forEach((lineItem, index) => {
    for (let row = 0; row < 4; row += 1) {
      for (let column = 0; column < 5; column += 1) {
        const icon = getActualIcon(column, row);
        if (lineItem.allLines[row][column] === 1) {
          icon.changeState(iconStates.win);
        } else {
          icon.changeState(iconStates.noWin);
        }
        if (lineItem.icons[row][column]) {
          allLinesBones[index][column].y = -icon.y + (isMobile() ? 100 : 170);
        }
      }
    }
    if (lineItem.line) {
      gameMainDrawer.lineWinBar.allWinLines[index].visible = true;
      gameMainDrawer.lineWinBar.allWinLines[index].play('animation1');
    }
  });
}
const resetIcons = () => {
  const rowsCount = 4;
  const columnsCount = 5;
  for (let row = 0; row < rowsCount; row += 1) {
    for (let column = 0; column < columnsCount; column += 1) {
      resetIcon(getActualIcon(column, row), true);
    }
  }
};

async function startLineWin() {
  if (!linesData?.length) {
    return;
  }
  const currentLineIndex = iterations % linesData.length;
  const lineData = linesData[currentLineIndex].icons;
  winBarStore.setWinMatrix(lineData);
  const promises = [];
  const rowsCount = 4;
  const columnsCount = 5;

  for (let row = 0; row < rowsCount; row += 1) {
    for (let column = 0; column < columnsCount; column += 1) {
      const icon = getActualIcon(column, row);
      if (!linesData?.length) {
        return;
      }
      // eslint-disable-next-line no-continue
      if (!icon) continue;
      if (!icon._winData) icon._winData = {};
      if (lineData[row][column]) {
        removeFromGameTimer(allLineGameTimeEvent);
        removeFromGameLoop(allLineResolver);
        allLinePromise = new Promise((resolve) => {
          allLineResolver = resolve;
          allLineGameTimeEvent = addToGameTimer(1000, allLineResolver);
        });
        if (isAllWinLine && linesData.length > 1) {
          isAllWinLine = false;
          startAllLineWin(linesData);
          await allLinePromise;

          resetIcons();
          isSpinEnd = true;
          spinBarStore.setIsSpinStart(false);
          spinBarStore.setIsDoubleClick(false);
          gameMainDrawer.menuBar.toggleMenuIconOpacity();
        }
        if (iterations >= linesData.length && applicationStore.isMaintenance) {
          iframeService.reloadFrame();
        }

        if (linesData.length > 1) {
          if (
            spinBarStore.selectedAutoBetCount &&
            winBarStore.spinResultOdd < MIN_BIG_WIN_POPUPS_ODD
          ) {
            stopWin();
            gameMainDrawer.spinBar.handleDoSpin();
            return;
          }
        }
        if (
          ((+icon.iconNumber !== 10 && +icon.iconNumber !== 11) || icon.currentState !== 'win') &&
          linesData[currentLineIndex]?.line
        ) {
          if (allLinesBones[currentLineIndex]) {
            allLinesBones[currentLineIndex][column].y = -icon.y + (isMobile() ? 100 : 170);
            gameMainDrawer.lineWinBar.setIsShowOneLineVisible(currentLineIndex);
            gameMainDrawer.lineWinBar.allWinLines[currentLineIndex].play('animation3');
          }
        }
        lineData[row][column] === 1
          ? icon.changeState(iconStates.win)
          : icon.changeState(iconStates.noWin);
        icon.iconNumber === 9 && icon.changeState(iconStates.noWin);
        promises.push(
          new Promise((resolve) => {
            icon._winData.listener = icon.addOnCompleteHandler(resolve);
            icon._winData.resolver = resolve;
          })
        );
      } else {
        icon._winData.listener = null;
        icon._winData.resolver = null;
        icon.changeState(iconStates.noWin);
      }
    }
  }
  await Promise.all(promises);
  if (linesData.length === 1 && !isSpinEnd) {
    isSpinEnd = true;
    spinBarStore.setIsSpinStart(false);
    spinBarStore.setIsDoubleClick(false);
  }
  gameMainDrawer.menuBar.toggleMenuIconOpacity();
  if (
    spinBarStore.selectedAutoBetCount &&
    winBarStore.spinResultOdd < MIN_BIG_WIN_POPUPS_ODD &&
    linesData.length === 1
  ) {
    gameMainDrawer.spinBar.handleDoSpin();
  }
  if (interrupted) return;
  iterations += 1;
  nextLineTimeout = setTimeout(startLineWin, 0);
}

const resetIcon = (icon, isInit) => {
  if (icon) {
    icon.changeState(isInit ? iconStates.noWin : iconStates.idle);
    if (icon._winData) {
      if (icon._winData.listener) {
        icon._winData.listener();
        icon._winData.listener = null;
      }
      if (icon._winData.resolver) {
        icon._winData.resolver();
        icon._winData.resolver = null;
      }
    }
  }
};

function stopWin() {
  // spinBarStore.setIsSpinStart(false);
  clearTimeout(nextLineTimeout);
  removeFromGameTimer(allLineGameTimeEvent);
  interrupted = true;
  iterations = 0;
  linesData = [];
  allLinesBones.forEach((item) => {
    item.forEach((el) => {
      el.y = 0;
    });
  });
  removeFromGameTimer(linWinTime);
  gameMainDrawer.lineWinBar.winWinAmount.visible = false;
  const rowsCount = 4;
  const columnsCount = 5;
  for (let row = 0; row < rowsCount; row += 1) {
    for (let column = 0; column < columnsCount; column += 1) {
      resetIcon(getActualIcon(column, row));
    }
  }
  gameMainDrawer.lineWinBar.setIsShowAllLineVisible(false);
}

const handleSymbolAnimationPositionInMatrix = () => {
  let activeSymbolsMatrix;
  let activeSymbols = [];
  const winLines = [];
  let winLine = {};
  const allLinesMatrix = [
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0],
  ];
  winBarStore.wins.forEach((el) => {
    const currentActiveSymbols = [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ];
    activeSymbolsMatrix = [...currentActiveSymbols];
    if (el.line) {
      for (let i = 0; i < currentActiveSymbols[0].length; i += 1) {
        const row = WinningLinesCoordinate100[el.line - 1][i].x;
        const coll = WinningLinesCoordinate100[el.line - 1][i].y;
        if (i < el.count) {
          activeSymbolsMatrix[row][coll] = 1;
          allLinesMatrix[row][coll] = 1;
        } else {
          activeSymbolsMatrix[row][coll] = 2;
          allLinesMatrix[row][coll] = allLinesMatrix[row][coll] || 2;
        }
      }
    } else {
      const response = [[], [], [], []];
      for (let i = 0; i < gameStore.matrix.length; i += 1) {
        for (let j = 0; j < gameStore.matrix[i].length; j += 1) {
          response[j][i] = gameStore.matrix[i][j];
          if (response[j][i] === el.symbol) {
            activeSymbolsMatrix[j][i] = 1;
          }
        }
      }
    }

    activeSymbols = [...activeSymbols, activeSymbolsMatrix];
    winLine = {
      count: el.count,
      lines: activeSymbolsMatrix,
      allLines: allLinesMatrix,
      win: el.lineWinAmount,
      winCard: el.symbol,
      line: el.line,
    };
    winLines.push(winLine);
  });

  return winLines;
};

const parseWinLinesData = () => {
  let winLines = [];
  const responseWins = handleSymbolAnimationPositionInMatrix();
  winLines = responseWins.map((responseWin) => {
    return {
      count: responseWin.count,
      icons: responseWin.lines,
      win: responseWin.win,
      allLines: responseWin.allLines,
      line: responseWin.line,
      winCard: responseWin.winCard,
    };
  });
  return winLines;
};

function startWin() {
  // bones = gameMainDrawer.lineWinBar.winningLine.skeleton.bones
  //   .filter((bone) => bone.x)
  //   .sort((a, b) => (a.x > b.x ? 1 : b.x > a.x ? -1 : 0));
  allLinesBones = gameMainDrawer.lineWinBar.allWinLines.map((el) =>
    el.skeleton.bones
      .filter((bone) => {
        return bone.data.name.includes('bone');
      })
      .sort((a, b) => (a.x > b.x ? 1 : b.x > a.x ? -1 : 0))
  );
  if (winBarStore.expandingWildData?.every((el) => !el)) {
    soundService.play(SoundTypes.WinningLineSound);
  }
  gameMainDrawer.slotBar.WinBarContainer.visible = true;
  interrupted = false;
  iterations = 0;
  linesData = parseWinLinesData();
  if (linesData.length && winBarStore.winAmount) {
    isAllWinLine = true;
    isSpinEnd = false;
    startLineWin();
  }
}
